import { DefaultApi as UserAuthServiceApi } from 'ctp-user-auth-service';
import { routes } from '@/constants/routes/routes';
import userManager from '@/auth';

const apiConfig = {
  accessToken: () => userManager.getApiKey().replace('Bearer ', '')
};

export const userAuthServiceApi = new UserAuthServiceApi(apiConfig, routes.apiRoutes.basePath);

export default userAuthServiceApi;
